import React, { useMemo } from "react";
import type { Schedule } from "@/types";
import CalendarModal from "./CalendarModal.tsx";

interface RoleCalendarModalProps {
    open: boolean;
    onClose: () => void;
    roleName: string;
    schedule: Schedule;
    problematicShiftIds?: string[];
    shiftConstraintBreaches?: { [shiftId: string]: string[] };
    periodStartDate?: string;
    periodEndDate?: string;
    onShiftClick?: (shiftId: string) => void;
    onPrev?: () => void;
    onNext?: () => void;
    hasPrev?: boolean;
    hasNext?: boolean;
}

const RoleCalendarModal: React.FC<RoleCalendarModalProps> = (
    {
        open,
        onClose,
        roleName,
        schedule,
        problematicShiftIds,
        shiftConstraintBreaches,
        periodStartDate,
        periodEndDate,
        onShiftClick,
        onPrev,
        onNext,
        hasPrev,
        hasNext,
    }) => {
    const filteredShifts = useMemo(() => {
        return schedule.shifts.filter(shift => {
            const shiftRole = shift.roleName || shift.requiredSkill || "Autre";
            return shiftRole === roleName;
        });
    }, [schedule.shifts, roleName]);

    return (
        <CalendarModal
            open={open}
            onClose={onClose}
            title={roleName}
            filteredShifts={filteredShifts}
            schedule={schedule}
            problematicShiftIds={problematicShiftIds}
            shiftConstraintBreaches={shiftConstraintBreaches}
            periodStartDate={periodStartDate}
            periodEndDate={periodEndDate}
            badgeContentType="employee"
            onShiftClick={onShiftClick}
            onPrev={onPrev}
            onNext={onNext}
            hasPrev={hasPrev}
            hasNext={hasNext}
        />
    );
};

export default RoleCalendarModal;
